export const CREATE_ACCOUNT = 'CREATE_ACCOUNT';
export const SET_CREATE_ACCOUNT_PAGE = 'SET_CREATE_ACCOUNT_PAGE';



// WEBPACK FOOTER //
// ./app/actions/account.js